/* Per-track BPM + key readout for the product tracklist.
 *
 * The tracklist itself is rendered by paranoise-player.js, which builds it from
 * the catalog / Discogs / iTunes and carries no tempo data. record-data-block
 * can add a readout, but only for records whose custom.tracklist metafield was
 * written in the enriched "A1. Title — 135 BPM · 7A" form, which is a minority
 * of the catalogue — which is why most pages showed no BPM at all.
 *
 * The collector already knows the tempo and key of 23,606 tracks. This fills in
 * every row record-data-block left bare, from pn-track-meta.js.
 *
 * Runs after the tracklist appears (it is rendered async), and never overwrites
 * a readout that is already there.
 */
(function () {
  'use strict';

  /* FNV-1a 32-bit, base 36 — mirrors hkey() in build_reco_assets.py.
     Math.imul, not `*`: the product of a 32-bit hash and the FNV prime runs to
     2^56, past the 2^53 where a JS number stops being exact, so plain
     multiplication silently drifts away from the Python that built the table. */
  function hkey(s) {
    /* over UTF-8 BYTES, like the Python. A few dozen handles are Persian or
       Chinese, and hashing UTF-16 code units instead would miss exactly those. */
    var bytes = new TextEncoder().encode(s);
    var h = 0x811c9dc5;
    for (var i = 0; i < bytes.length; i++) {
      h ^= bytes[i];
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h.toString(36);
  }

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    /* pathname keeps non-ASCII handles percent-encoded; the table is keyed by
       the decoded handle */
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  /* "A1|135|7A;A2|135|4A" -> [{pos, bpm, key}, ...] */
  function parseMeta(blob) {
    return blob.split(';').map(function (row) {
      var p = row.split('|');
      return { pos: p[0] || '', bpm: p[1] || '', key: p[2] || '' };
    });
  }

  /* §C7 is now fixed AT SOURCE and this filter is deliberately gone.

     I used to drop any BPM of exactly 200: it was the 6th most common value
     in the catalogue while 201 appeared 6 times, which is a ceiling, not a
     measurement. The collector chat has since found the cause — vinylfuture's
     BPM endpoint saturates at 200 and never returns higher — and suppressed
     517 tracks in the data itself. Only 16 tracks still read exactly 200, and
     they are on punk and metal records from other sources, where 200 is real.

     Filtering here as well would now hide those 16 correct values. A gap
     beats a wrong value; it does not beat a right one. */
  /* The key is deliberately NOT rendered (Rue, 2026-09-05). entry.key is still
     parsed and still present in the table, but it does not reach the page: the
     published key data is not trustworthy yet (an earlier backfill assumed a
     major mode for 9,474 modeless root notes, plus 511 detector estimates).
     Dropping it here covers every row this script fills; the rows filled from
     the tracklist metafield are handled in record-data-block.liquid. Restore
     by putting the pushed key back. */
  function label(entry) {
    var bits = [];
    if (entry.bpm) bits.push(entry.bpm + ' BPM');
    return bits.join(' · ');
  }

  function decorate() {
    var mount = document.getElementById('pn-tracklist-mount');
    if (!mount) return true;                       // nothing to decorate, ever

    var items = mount.querySelectorAll('.pn-tracklist-item');
    if (!items.length) return false;               // not rendered yet

    var handle = currentHandle();
    var table = window.PN_TRACK_META;
    if (!handle || !table) return true;
    var blob = table[hkey(handle)];
    if (!blob) return true;                        // collector has no tempo here

    var meta = parseMeta(blob);
    var byPos = {};
    meta.forEach(function (e) { byPos[e.pos.toUpperCase()] = e; });

    /* paranoise-player.js labels sides "A1", "B2"… when it has a real tracklist,
       but plain "1", "2"… when it fell back to iTunes track numbers. Position
       matching handles the first; same-length index matching handles the
       second. Anything else is left alone rather than guessed at. */
    var sides = [];
    items.forEach(function (item) {
      var el = item.querySelector('.pn-tracklist-side');
      sides.push(el ? el.textContent.trim().toUpperCase() : '');
    });
    var matched = sides.filter(function (s) { return byPos[s]; }).length;
    var useIndex = matched === 0 && items.length === meta.length;

    items.forEach(function (item, i) {
      if (item.querySelector('.pn-sheet-readout')) return;   // metafield won
      var entry = useIndex ? meta[i] : byPos[sides[i]];
      if (!entry) return;
      var text = label(entry);
      if (!text) return;
      if (!item.querySelector('.pn-sheet-leader')) {
        var leader = document.createElement('span');
        leader.className = 'pn-sheet-leader';
        item.appendChild(leader);
      }
      var span = document.createElement('span');
      span.className = 'pn-sheet-readout';
      span.textContent = text;
      item.appendChild(span);
    });
    return true;
  }

  function start() {
    if (decorate()) return;
    var mount = document.getElementById('pn-tracklist-mount');
    if (!mount) return;
    var obs = new MutationObserver(function () { if (decorate()) obs.disconnect(); });
    obs.observe(mount, { childList: true, subtree: true });
    /* record-data-block decorates on the same mutation; re-run once after it so
       we only fill the rows it had no data for. */
    setTimeout(function () { decorate(); }, 1200);
    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
